import type { DefaultTheme } from "../themes";
import { getButtonVariantStyle } from "./getButtonVariantStyle";

const uploadPhoto = (theme: DefaultTheme) => {
  const transparentButton = getButtonVariantStyle(theme, "transparent");
  return {
    button: {
      ...transparentButton,
      color: theme.palette.text.main,
      padding: "12px 30px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        marginLeft: 0,
        marginTop: theme.spacing(2),
      },
    },
    badgeContentIcon: {
      background: "red",
      color: "black",
    },
  };
};

export default uploadPhoto;
